export const getMenuItems = (userGroups = [], adminPings) => {
  const isAdmin = userGroups.includes('admin');
  const isFacilitator = userGroups.includes('facilitator');

  return [
    {
      name: 'Dashboard',
      path: '/dashboard',
      hidden: false,
      subItems: [],
    },
    {
      name: 'My Shop',
      path: undefined,
      hidden: false,
      subItems: [
        {
          name: 'My Product Listings',
          path: '/shop/product-listings',
          hidden: false,
          tooltipText: 'View your product listing (products you uploaded and have been verified.)',
        },
        {
          name: 'Upload Product Listing',
          path: '/shop/upload-product-listing',
          hidden: false,
          tooltipText: 'Upload your product to be listed on the platform.',
        },
        {
          name: 'My Buyer Listings',
          path: '/shop/buyer-listings',
          hidden: false,
          tooltipText: 'View your buyer listing (products you expressed interest in).',
        },
        {
          name: 'Upload Buyer Listing',
          path: '/shop/upload-buyer-listing',
          hidden: false,
          tooltipText: 'Upload your buyer listing (express interest in certain products).',
        },
        { name: 'ATP-Wallet', path: '/shop/wallet', hidden: false, tooltipText: undefined },
        { name: 'My Rewards', path: '/shop/rewards', hidden: true, tooltipText: undefined },
        {
          name: 'Deal Room',
          path: '/shop/deal-room',
          hidden: false,
          tooltipText: 'View any deals you or someone else has initiated.',
        },
      ],
    },
    {
      name: 'The Market',
      path: undefined,
      hidden: false,
      subItems: [
        {
          name: 'Product Listings',
          path: '/market/product-listings',
          hidden: false,
          tooltipText: 'View all verified products from different suppliers on the platform.',
        },
        { name: 'Bookmarked Listings', path: '/market/bookmarked-listings', hidden: true, tooltipText: undefined },
        {
          name: 'Buyer Listings',
          path: '/market/buyer-listings',
          hidden: false,
          tooltipText: 'View all buyers listing from prospective buyers.',
        },
        { name: 'Featured Listings', path: '/market/featured-listings', hidden: true, tooltipText: undefined },
        {
          name: 'Market Buzz',
          path: '/market/market-buzz',
          hidden: false,
          tooltipText: 'View people’s thoughts and interests and get a chance to interact with buyers and suppliers.',
        },
        {
          name: 'Direct Messages',
          path: '/market/direct-messages',
          hidden: false,
          tooltipText: 'Direct message anyone.',
        },
      ],
    },
    {
      name: isAdmin ? 'Admin' : 'Facilitator',
      path: undefined,
      hidden: !isAdmin && !isFacilitator,
      subItems: [
        {
          name: 'Product Specifications',
          path: '/admin/product-specifications',
          hidden: !isAdmin,
          adminNotifications: true,
          pings: adminPings ? adminPings.productSpecificationsPings : 0,
        },
        {
          name: 'Product Management',
          path: '/admin/product-management',
          hidden: !isAdmin,
          adminNotifications: true,
          pings: adminPings ? adminPings.productManagementPings : 0,
        },
        {
          name: 'Account Management',
          path: '/admin/account-management',
          hidden: !isAdmin,
          adminNotifications: true,
          pings: adminPings ? adminPings.accountManagementPings : 0,
        },
        {
          name: 'Support',
          path: '/admin/support',
          hidden: false,
          adminNotifications: true,
          pings: adminPings ? adminPings.supportPings : 0,
        },
        {
          name: 'Market Buzz Management',
          path: '/admin/market-buzz-management',
          hidden: true,
          adminNotifications: true,
          pings: adminPings ? adminPings.marketBuzzManagementPings : 0,
        },
        {
          name: 'Deal Room Management',
          path: '/admin/deal-room-management',
          hidden: false,
          adminNotifications: true,
          pings: adminPings ? adminPings.dealRoomManagementPings : 0,
        },
        {
          name: 'User Role Management',
          path: '/admin/user-role-management',
          hidden: !isAdmin,
          adminNotifications: true,
          pings: adminPings ? adminPings.userRoleManagementPings : 0,
        },
      ],
    },
    {
      name: 'Reports',
      path: undefined,
      hidden: !isAdmin,
      subItems: [
        {
          name: 'User Metrics',
          path: '/reports/user-metrics',
          hidden: false,
        },
        {
          name: 'Deal Room Statistics',
          path: '/reports/deal-room-statistics',
          hidden: false,
        },
      ],
    },
  ];
};

export const getSettingsMenuItems = () => {
  return [
    { name: 'My Profile', path: '/my-profile', hidden: false },
    { name: 'My Preferences', path: '/my-preferences', hidden: false },
    { name: 'Verification', path: '/verification', hidden: false },
    { name: 'Help Center', path: '/help-center', hidden: false },
    { name: 'Sign Out', path: '/', hidden: false },
  ];
};
